














































import { Component, Vue, Emit, PropSync, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";

@Component
export default class AuthPwdDialog extends Vue {
  @PropSync("visible", { type: Boolean, default: false })
  dialogVisible: boolean;

  private isSaveLoading = false;
  form: any = {
    password: ""
  };
  passwordType1: any = true;
  passwordType2: any = true;
  second: any = 60;
  get rules() {
    return {
      password: [
        {
          required: true,
          message: "请输入授权密码",
          trigger: "blur"
        }
      ]
    };
  }

  @Watch("visible")
  watchVisibleFn(val) {
    if (val) {
      // 初始化弹窗数据
    } else {
      let $form: any = this.$refs.form;
      $form && $form.resetFields();
    }
  }
  created() {
    // 获取导出项配置
  }

  triggerPassword(name) {
    this[name] = !this[name];
  }

  submit() {
    let $form: any = this.$refs.form;
    $form.validate(async val => {
      if (val) {
        // this.dialogVisible = false;
        this.$emit("submit", this.form.password);
      }
    });
  }

  isSend: any = false;
  msgLoading: any = false;
  everSendMsg: any = false;
  async sendMsgFn() {
    if (this.msgLoading) return;
    try {
      this.msgLoading = true;
      // await this.sendSalesManVerificationCode();
      this.isSend = true;
      let info: any = "验证码发送成功";
      this.$message.success(info);
      this.timerOutFn();
      this.everSendMsg = true;
    } finally {
      this.msgLoading = false;
    }
  }
  timer: any = null;
  timerOutFn() {
    this.timer = setInterval(() => {
      if (this.second > 1) {
        this.second--;
        // localStorage.setItem("sendSec", this.second);
      } else {
        clearInterval(this.timer);
        // localStorage.removeItem("sendSec");
        this.second = 60;
        this.isSend = false;
        this.everSendMsg = false;
      }
    }, 1000);
  }
}
